import TopBanner from "../StylisticComponents/TopBanner";

function PrivacyPolicy() {
    return (
        <div>
            <TopBanner>
                <h1 className="display-4 white-text hind-mysuru-bold">Privacy Policy</h1>
            </TopBanner>
            <div className="container pt-5">
                <div>
                    <h1>Privacy Policy — MapleMark Media Inc.</h1>
                    <b>Last updated:</b> September 30th, 2025
                </div>
                <div className="pt-3">
                    <h2>1) Overview</h2>
                    <div>
                        This Privacy Policy explains how MapleMark collects, uses, discloses, and protects personal information when you use our social-media tool, website, and related services (together, the “Service”). We operate in Canada and handle personal information in accordance with applicable laws, including PIPEDA. If you are located in other jurisdictions (e.g., EU/UK/California), additional rights may apply (see Section 10).
                    </div>
                </div>
                <div className="pt-3">
                    <h2>2) What We Collect</h2>
                    <div>
                        We collect personal information in these categories:<br></br>
&bull; Account & Contact Data: name, email, password (hashed), organization, role, billing contact.<br></br>


&bull; Billing Data (if paid): payment method details are processed by our payment processor; we receive limited details (e.g., last 4 digits, card type, transaction IDs, billing address).<br></br>


&bull; Usage & Device Data: IP address, device/browser type, pages viewed, actions in the app, timestamps, crash logs, and diagnostics.<br></br>


&bull; Content & Connections: social-media page/account IDs you connect, publishing schedules, drafts, analytics results, and content you upload or import.<br></br>


&bull; Support Data: communications with us, including emails, chat messages, and support tickets.<br></br>


&bull; Cookies & Similar Tech: see Section 7.<br></br>
                    </div>
                </div>
                <div className="pt-3">
                    <h2>3) Sources of Information</h2>
                    <div>
                        &bull; Directly from you (sign-up, settings, support).<br></br>


&bull; Automatically through your use of the Service.<br></br>


&bull; From third-party platforms you choose to connect (subject to their permissions and policies).<br></br>


&bull; From service providers (e.g., anti-fraud, analytics, payment processors).

                    </div>
                </div>
                <div className="pt-3">
                    <h2>4) How We Use Information</h2>
                    <div>
                        We use personal information to:<br></br>
&bull; Provide, secure, and maintain the Service.<br></br>


&bull; Authenticate users and manage accounts.<br></br>


&bull; Connect with third-party social platforms as you direct.<br></br>


&bull; Process payments and billing.<br></br>


&bull; Provide support and communicate about updates or changes.<br></br>


&bull; Analyze and improve performance, features, and user experience.<br></br>


&bull; Comply with law, prevent fraud and abuse, and enforce our Terms.<br></br>


Legal bases (where required): performance of a contract, legitimate interests (e.g., security, improvement), consent (e.g., certain marketing/cookies), and legal obligations.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>5) Sharing & Disclosures</h2>
                    <div>
                        We share personal information with: <br></br>
&bull; Service Providers/Processors: hosting, infrastructure, analytics, payment processing, email delivery, customer support, security. They must follow our instructions and protect your data. <br></br>


&bull; Third-Party Platforms You Connect: as necessary to publish content and retrieve analytics you request.<br></br>


&bull; Legal/Compliance: if required by law, to protect rights, safety, or security.<br></br>


&bull; Business Transfers: in the event of a merger, acquisition, financing, or sale of assets (with appropriate protections).
                    </div>
                </div>
                <div className="pt-3">
                    <h2>6) Data Retention</h2>
                    <div>
                        We keep personal information only as long as necessary for the purposes in this Policy, to comply with legal obligations, and to resolve disputes. We delete or de-identify data when it’s no longer needed. You can request deletion (see Section 9).
                    </div>
                </div>
                <div className="pt-3">
                    <h2>7) Cookies & Tracking</h2>
                    <div>
                        We use:<br></br>
&bull; Strictly Necessary Cookies (authentication, security).<br></br>


&bull; Performance/Analytics (to understand usage and improve the Service).<br></br>


&bull; Functional (remember your preferences).<br></br>
 Where required, we obtain consent for non-essential cookies. You can manage cookies in your browser settings; some features may not function without them.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>8) Security</h2>
                    <div>
                        We use administrative, technical, and physical safeguards designed to protect personal information (e.g., encryption in transit, access controls, logging). No method is 100% secure; please protect your credentials and notify us of any suspected compromise.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>9) Your Rights & Choices</h2>
                    <div>
                        Depending on your location, you may have rights to access, correct, delete, or port your personal information, or to object to or restrict certain processing. You can manage many settings in your account. For additional requests, contact us (Section 12). We will verify your identity and respond as required by law.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>10) Regional Disclosures</h2>
                    <div>
                        &bull; Canada (PIPEDA): You have rights to access and correct personal information and to challenge our compliance.<br></br>


&bull; EU/EEA/UK (GDPR/UK GDPR): We act as a controller for your account data and as a processor for content you direct us to process on your behalf. You may have rights to access, rectification, erasure, portability, restriction, and objection, and to lodge a complaint with a supervisory authority. Where data is transferred outside the EEA/UK, we use appropriate safeguards (e.g., Standard Contractual Clauses).<br></br>


&bull; California (CCPA/CPRA): We do not “sell” personal information. You may have rights to know, delete, correct, and opt out of sharing for cross-context behavioral advertising (if applicable).
                    </div>
                </div>
                <div className="pt-3">
                    <h2>11) Children’s Privacy</h2>
                    <div>
                        The Service is not directed to children under 13 (or older age as defined by local law). We do not knowingly collect personal information from children; if we learn we have, we will delete it.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>12) Data Controller & Contact</h2>
                    <div>
                        Data Controller: MapleMark Media Inc.<br></br>
Address: 4226 Duke of York Blvd, Mississauga, ON L5B 4C1<br></br>
Email: info@maplemarkmedia.com
                    </div>
                </div>
                <div className="pt-3">
                    <h2>13) International Transfers</h2>
                    <div>
                        We may store and process information in countries other than where you live. We implement appropriate safeguards required by law for cross-border transfers.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>14) Changes to this Policy</h2>
                    <div>
                        We may update this Policy from time to time. We’ll post the updated date above and, where required, provide notice. Your continued use constitutes acceptance.
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default PrivacyPolicy;